import { render } from "./UiActionButton.vue?vue&type=template&id=65f305ec&ts=true"
import script from "./UiActionButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiActionButton.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiActionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65f305ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65f305ec', __exports__)) {
    api.reload('65f305ec', __exports__)
  }
  
  module.hot.accept("./UiActionButton.vue?vue&type=template&id=65f305ec&ts=true", () => {
    api.rerender('65f305ec', render)
  })

}


export default __exports__